import { Box, Button, Card, CardContent, Stack, Tab, Tabs, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import server from '../../../services/server';
import useErrors from '../../../hooks/useErrors';
import { useAuth } from '../../../context/AuthContext';
import Logo from '../../../assets/logo.png';

const ROLE_LABELS = {
    admin: 'Administrador',
    manager: 'Gerente',
    user: 'Atendente',
    owner: 'Proprietário',
};

export default function AdvertiserInviteAccept() {
    const { token } = useParams();
    const { Login } = useAuth();
    const { setErrors, enqueueSnackbar } = useErrors();
    const [invite, setInvite] = useState(null);
    const [mode, setMode] = useState('register');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        let active = true;
        server
            .get(`advertiser/invites/${token}`)
            .then(({ data }) => {
                if (!active) return;
                const row = data?.data;
                setInvite(row);
                setMode(row?.userExists ? 'login' : 'register');
            })
            .catch(error => {
                if (active) setErrors(error);
            });
        return () => {
            active = false;
        };
    }, [token, setErrors]);

    const handleAccept = async event => {
        event.preventDefault();
        if (mode === 'register' && password !== confirmPassword) {
            enqueueSnackbar('As senhas não conferem.', { variant: 'warning' });
            return;
        }
        try {
            setSubmitting(true);
            const { data } = await server.post(`advertiser/invites/${token}/accept`, { mode, password });
            const result = data?.data;
            enqueueSnackbar('Convite aceito. Bem-vindo!', { variant: 'success' });
            await Login({
                token: result.token,
                refreshtoken: result.refreshToken,
                user: result.user,
                advertiser: result.advertiser,
            });
        } catch (error) {
            setErrors(error);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Stack minHeight="100vh" alignItems="center" justifyContent="center" sx={{ bgcolor: 'grey.100', p: 2 }}>
            <Card sx={{ width: '100%', maxWidth: 460 }}>
                <CardContent>
                    <Stack spacing={2} component="form" onSubmit={handleAccept}>
                        <Box component="img" src={Logo} alt="Eurobem" sx={{ width: 140 }} />
                        <Typography variant="h5" fontWeight={800}>
                            Convite do anunciante
                        </Typography>
                        {!invite ? (
                            <Typography color="text.secondary">Carregando convite...</Typography>
                        ) : !invite.canAccept ? (
                            <Typography color="text.secondary">
                                Este convite não está mais disponível ({invite.status}).
                            </Typography>
                        ) : (
                            <>
                                <Typography variant="body2" color="text.secondary">
                                    {invite.advertiser?.name || 'Anunciante'} convidou <strong>{invite.email}</strong> como{' '}
                                    {ROLE_LABELS[invite.role] || invite.role}.
                                </Typography>
                                <Tabs
                                    value={mode}
                                    onChange={(_event, next) => setMode(next)}
                                    variant="fullWidth"
                                >
                                    <Tab value="register" label="Criar senha" disabled={invite.userExists} />
                                    <Tab value="login" label="Já tenho conta" />
                                </Tabs>
                                <TextField label="E-mail" value={invite.email} disabled fullWidth />
                                <TextField
                                    required
                                    fullWidth
                                    type="password"
                                    label={mode === 'login' ? 'Senha da conta' : 'Senha'}
                                    value={password}
                                    onChange={event => setPassword(event.target.value)}
                                />
                                {mode === 'register' && (
                                    <TextField
                                        required
                                        fullWidth
                                        type="password"
                                        label="Confirmar senha"
                                        value={confirmPassword}
                                        onChange={event => setConfirmPassword(event.target.value)}
                                    />
                                )}
                                <Button type="submit" variant="contained" disabled={submitting}>
                                    Aceitar convite
                                </Button>
                            </>
                        )}
                        <Button component={Link} to="/anunciante/login">
                            Ir para o login
                        </Button>
                    </Stack>
                </CardContent>
            </Card>
        </Stack>
    );
}
